import Select from "@/v2-ui/select"
import Tooltip from "@/v2-ui/tooltip"
import {
  PERIOD_OPTIONS,
  type Period,
} from "@/v2-backoffice-client/signIn/signIn.period"

export type SignInPeriodSelectProps = {
  value: Period
  onChange(value: Period): void
}

// Compact labelled period control, styled to sit inline among the table's
// toolbar filters (matches .ui-table-toolbar-filter). Rendered per tab via
// each table's toolbarExtra; the period itself is owned one level up so the
// two tabs stay in sync.
function SignInPeriodSelect(props: SignInPeriodSelectProps) {
  const { value, onChange } = props

  return (
    <div className="ui-table-toolbar-filter">
      <label className="ui-table-toolbar-filter-label">
        <Tooltip>
          <Tooltip.Trigger asChild tabIndex={-1}>
            <span>Period</span>
          </Tooltip.Trigger>
          <Tooltip.Content
            side="top"
            className="ui-tooltip-content--panel max-w-[280px]"
          >
            Time window for the sign-ins shown below. The table, filters, and
            risk scores all cover this range.
          </Tooltip.Content>
        </Tooltip>
      </label>
      <Select value={value} onValueChange={(next) => onChange(next as Period)}>
        <Select.Trigger size="xs" className="w-28">
          <Select.Value />
        </Select.Trigger>
        <Select.Content>
          {PERIOD_OPTIONS.map((opt) => (
            <Select.Item key={opt.value} value={opt.value}>
              {opt.label}
            </Select.Item>
          ))}
        </Select.Content>
      </Select>
    </div>
  )
}

export default SignInPeriodSelect
